<template>
  <div class="Developer Page">
    <div class="Page-Content dev-content">
      <swiper
        class="swiper swiperDeveloper"
        :options="swiperDeveloper"
        ref="swiperOption"
      >
        <swiper-slide>
          <div class="dev-content-item">
            <div class="dev-content-item-logo">
              <img src="@/assets/developers/sunwaymcl_logo.webp" alt="" />
            </div>
            <div class="dev-content-item-img">
              <img src="@/assets/developers/Tembusu Grand.png" alt="" />
            </div>
            <div class="dev-content-item-bottom">
              <img
                class="dev-content-item-img-right"
                src="@/assets/developers/Leedon Green.png"
                alt=""
              />
              <p>
                Established in 1963, MCL Land is a member of the Jardine
                Matheson Group under Hongkong Land Holdings, a major listed
                property investment, management and development group. The Group
                owns and manages more than 850,000 sq. m. of prime office and
                luxury retail property in key Asian cities, principally in Hong
                Kong, Singapore, Beijing and Jakarta. Its properties hold
                industry leading green building certifications and attract the
                world’s foremost companies and luxury brands as tenants.
                </p>
                <p>
                As one of Singapore’s leading private developers, Sunway MCL focuses on delivering premium, timeless developments defined by design excellence, enduring craftsmanship, and a deep sense of care and connection. Its portfolio of residential projects includes Tembusu Grand, The Continuum, Piccadilly Grand, Terra Hills, Leedon Green and Parc Esta.
                <br />
                <br />
                Backed by Sunway Group’s financial strength and integrated ecosystem spanning property, construction, healthcare, education and hospitality, the company continues to strengthen its position in Singapore’s property landscape and contribute to the city-state’s long-term urban progress.
                </p>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="dev-content-item">
            <div class="dev-content-item-logo">
              <img src="@/assets/developers/logo2.png" alt="" />
            </div>
            <div class="dev-content-item-img">
              <img src="@/assets/developers/Nava Park.png" alt="" />
            </div>
            <div class="dev-content-item-bottom">
              <img
                class="dev-content-item-img-right"
                src="@/assets/developers/Indonesia.png"
                alt=""
              />
              <p>
                Listed on the Singapore Exchange and headquartered in Singapore,
                Sinarmas Land Limited is engaged in diverse sub-sectors of the
                property business, including township development, residential,
                commercial, industrial, and hospitality-related properties
                through its developments and investments in Indonesia, Malaysia,
                Singapore, China, Australia and the United Kingdom.
                </p>
                <p>
                As one of the largest developers in Indonesia, we strive for
                excellence in creating opulence yet practical abodes for our
                occupants. We have developed notable residential projects in
                Jakarta, such as The Zora, Southgate and Nava Park. Our
                diversified property portfolio also includes city and township
                developments, such as BSD City, Grand Wisata and Kota Deltamas
                in Greater Jakarta, prime commercial office buildings such as
                Sinar Mas Land Plaza Jakarta, Sinarmas MSIG Tower in CBD Jakarta
                as well as Alphabeta Building in London,United Kingdom.

                <!-- Listed on the Singapore Exchange and headquartered in Singapore, Sinarmas Land Limited is engaged in diverse sub-sectors of the property business, including township development, residential, commercial, industrial, and hospitality-related properties through its developments and investments in Indonesia, Malaysia, Singapore, China, Australia and the United Kingdom.
            <br>
            <br>
            As one of the largest developers in Indonesia, we strive for excellence in creating opulent yet practical abodes for our occupants. We have designed and developed notable residential projects in Jakarta, such as The Zora, The Element Jakarta, and Nava Park. Our diversified property portfolio also includes city and township developments, such as BSD City, Grand Wisata and Kota Deltamas in Greater Jakarta, prime commercial office buildings such as Sinar Mas Land Plaza Jakarta,  Sinarmas MSIG Tower in CBD Jakarta as well as Alphabeta Building in London, United Kingdom. We also invested in Dana Investasi Real Estat Simas Plaza Indonesia, an Indonesian-listed REIT which owns Grand Hyatt Jakarta and Plaza Indonesia.
            <br>
            <br>
            With over 50 years of proven track record, we continue to seek new heights as a regional real estate player to meet the ever-changing demands of real estate users and endeavour to build a better future for the years to come.
          -->
              </p>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev" style="left: 5%; top: 45%">
        <img src="@/assets/btn/left1.png" alt="" />
      </div>
      <div class="swiper-button-next" style="right: 5%; top: 45%">
        <img src="@/assets/btn/right1.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      swiperDeveloper:{
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      }
    };
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="less">
.swiper-slide {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  // border-radius: 10px;
  // background-color: #000000;
}

.Developer {
  .dev-content {
    height: 93%;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: flex-start;
    .swiper-button-prev,
      .swiper-button-next {
        display: flex;
        justify-content: center;
        align-items: center;
        background: none;
        img {
          max-height: 5rem;
          max-width: 5rem;
        }
      }
    .dev-content-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 850px;
      // width: 80%;

      .dev-content-item-logo {
        width: 25%;
        height: 45px;
        padding: 30px;
        img {
          max-width: 100%;
          // max-height: 100%;
        }
      }
      .dev-content-item-img {
        width: 100%;
        height: 500px;
        padding: 10px 0;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .dev-content-item-bottom {
        display: flex;
        flex-direction: row;
        width: 100%;
        .dev-content-item-img-right {
          width: 29%;
          // height: 200px;
          object-fit: cover;
          margin-right: 10px;
        }
        p {
          width: 285px;
          margin: 5px;
          // width: calc(71% - 10px);
          // column-count: 2;
          // column-gap: 20px;
          text-align: start;
          font-size: 14px;
        }
      }
    }
  }
}
</style>

